import React, {Fragment, useEffect, useState} from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import CasinoIcon from "@mui/icons-material/Casino";
import {v4} from "uuid";
import {rollerClose, rollerRoll, rollerSetKarma, rollerSetRoll, rollerSubscriber} from "../_helper/rollBehave";
import {IIni} from "../_interfaces/IIni";
import {IResult} from "../_interfaces/IResult";
import {s_app_cid, s_app_rid, s_app_sl, s_app_mobile} from "../_signals/s_app";
import {s_char} from "../_signals/s_char";
import {s_chars} from "../_signals/s_chars";
import updChar from "../_sig_api/updChar";
import {IniAdd} from "../_api/BEIni";
import {ModsSourceAdd} from "../_api/BEMods";
import {ResultsAdd} from "../_api/BEResult";
import {IRoller} from "../_interfaces/IRoller";
import {modSum} from "../_signals/s_char_calc";
import RollerHeader from "./RollerHeader";
import RollerContent from "./RollerContent";
import RollerResult from "./RollerResult";
import RollerTargetSelection from "./RollerTargetSelection";

export default function Roller() {

    const [roller, setRoller] = useState<IRoller>({
        rolled: false,
        open: false,
        roll: {
            attribute: '',
            canusekarma: false,
            karma: false,
            step_mod: 0,
            step: 0,
            strain: 0,
            title: '',
            vs:'',
            vsnum: 0,
            as: '',
            target: [],
            targetVS: '',
            as_fix: false
        },
        result: {
            time: 0,
            result: 0,
            rolled: '',
            step: 0,
            step_mod: 0,
            karma: '',
            successes: 0,
            success: false,
            vs: '',
            vsnum: 0,
            as: ''
        }
    })

    const [vs, setvs] = useState('')
    const [vstarget, setvstarget] = useState('')
    const [targets, setTargets] = useState<string[]>([])
    const [targetOpen, setTargetOpen] = useState<boolean>(false)

    useEffect(() => {
        rollerSubscriber.subscribe(roller => {
            setRoller(roller)
            setvs(roller.roll.targetVS)
        })
    }, [])

    const getRollVS = () => {
        if (!vs) return 0;
        if (vstarget === 's') {
            if (vs === 'kv') return s_char.value.kv + modSum(s_char.value.id, 'kv')
            if (vs === 'mv') return s_char.value.mv + modSum(s_char.value.id, 'mv')
            if (vs === 'sv') return s_char.value.sv + modSum(s_char.value.id, 'sv')
        }

        const rollTargets = getRollTarget();

        let rollvs = 0;
        rollTargets.forEach(t => {
            if (vs === 'kv') {
                const kv = (s_chars.value.get(t)?.kv ?? 0) + modSum(t, 'kv')
                if (['g', 'g+'].includes(vstarget) && kv > rollvs) rollvs = kv;
            }
            if (vs === 'mv') {
                const mv = (s_chars.value.get(t)?.mv ?? 0) + modSum(t, 'mv')
                if (['g', 'g+'].includes(vstarget) && mv > rollvs) rollvs = mv;
            }
            if (vs === 'sv') {
                const sv = (s_chars.value.get(t)?.sv ?? 0) + modSum(t, 'sv')
                if (['g', 'g+'].includes(vstarget) && sv > rollvs) rollvs = sv;
            }
        })
        if (['g+'].includes(vstarget)) {
            const add = rollTargets.length > 1 ? rollTargets.length - 1 : 0;
            rollvs = rollvs + add;
        }
        return rollvs;
    }

    const getRollTarget = () => {
        if (['z', 'e', 'g', 'g+'].includes(vstarget)) return targets;
        if (['s'].includes(vstarget)) return [s_char.value.id];
        return []
    }

    const roll = (karma: boolean) => {
        const rollvs = getRollVS()
        let roll = roller.roll;
        roll.vsnum = rollvs;
        roll.target = getRollTarget()
        rollerSetRoll(roll, true);
        rollerSetKarma(karma);
        let rolledResult = rollerRoll();

        if (rolledResult.rollas === 'ini') {
            const ini: IIni = {
                id: v4(),
                rid: s_app_rid.value,
                cid: s_char.value.id,
                name: s_char.value.name,
                nsc: s_char.value.nsc,
                result: rolledResult.result,
                wait: false,
                current: false
            }
            IniAdd(ini)
        }
        if (rolledResult.rollas === 'nsp' && !rolledResult.success) {
            ModsSourceAdd(s_app_cid.value, s_app_rid.value, 'state_niederschlag', '');
        }
        if (rolledResult.rollas === 'ep') {
            if (rolledResult.step > 0) {
                updChar([{k: 'ep_used', v: s_char.value.ep_used + 1}]);
            }
            const wounds = s_char.value.wunden;
            const heilt = rolledResult.result - wounds;
            if (heilt > 0) {
                updChar([{k: 'schaden', v: s_char.value.schaden - heilt}]);
                let result: IResult = {
                    id: v4(),
                    cid: s_char.value.id,
                    rid: s_app_rid.value,
                    title: 'heilt ' + heilt + '(' + heilt + ' - ' + wounds + ') Schaden',
                    name: s_char.value.name,
                    sl: s_app_sl.value,
                    nsc: s_char.value.nsc,
                    eff: '',
                    addEff: '',
                    time: 0,
                    step: 0,
                    step_mod: 0,
                    result: 0,
                    rolled: '',
                    success: false,
                    successes: 0,
                    karma: '',
                    rollas: '',
                    rollvs: 0

                };
                ResultsAdd(result);
            }
        }
    }

    const toggleAs = (as: string, e: any) => {
        const set = e.target.checked ? as : '';
        setRoller({...roller, roll: {...roller.roll, as: set}});
    }

    return (
        <Dialog open={roller.open} fullScreen={s_app_mobile.value} fullWidth={true} maxWidth={'xl'}>
            <RollerHeader rolled={roller.rolled}/>
            <DialogContent style={{position: 'relative'}}>
                {targetOpen && (
                    <RollerTargetSelection
                        vstarget={vstarget}
                        targets={targets}
                        setTargets={setTargets}
                        setTargetOpen={setTargetOpen}
                    />
                )}
                <RollerContent
                    roller={roller}
                    setRoller={setRoller}
                    vs={vs}
                    setvs={setvs}
                    vstarget={vstarget}
                    setvstarget={setvstarget}
                    toggleAs={toggleAs}
                    setTargetOpen={setTargetOpen}
                    targets={targets}
                />
                {roller.rolled && <RollerResult roller={roller}/>}
            </DialogContent>
            <DialogActions>
                {!targetOpen && !roller.rolled && (roller.roll.step > 0 || roller.roll.step_mod > 0) && (
                    <Fragment>
                        <CasinoIcon onClick={() => roll(false)}/>
                        {roller.roll.canusekarma && <CasinoIcon style={{color: 'red'}} onClick={() => roll(true)}/>}
                    </Fragment>
                )}
                {targetOpen && <Button onClick={() => setTargetOpen(false)}>Auswahl schließen</Button>}
                {!targetOpen && <Button onClick={() => rollerClose()}>Beenden</Button>}
            </DialogActions>
        </Dialog>
    );
}